import GoogleClient from "./GoogleClient";

export default abstract class GoogleClientBase extends GoogleClient {
  abstract getLink(fileId: string): string;
  abstract create(title: string): Promise<string>;
};
